



























import {Vue, Component} from 'vue-property-decorator';
import ItemTable from '@/components/common/ItemTable.vue';
import {GetMailMessagesViewRequest, GetMailMessagesView} from 'supporter';
import {i18nInObjectList} from '@/utils/i18n';
import {popupResize} from '@/utils/ncp';
@Component({
  components: {
    ItemTable
  }
})
export default class RecipientList extends Vue {
  private mailMessageView: GetMailMessagesView[] = [];
  private showItems: GetMailMessagesView[] = [];
  private statusCodeArr = [
    {
      value: 'READY',
      label: 'MAIL_SEND_LIST_POPUP_STATUS_CODE_READY'
    },
    {
      value: 'PROGRESS',
      label: 'MAIL_SEND_LIST_POPUP_STATUS_CODE_PROGRESS'
    },
    {
      value: 'COMPLETE',
      label: 'MAIL_SEND_LIST_POPUP_STATUS_CODE_COMPLETE'
    },
    {
      value: 'FAIL',
      label: 'MAIL_SEND_LIST_POPUP_STATUS_CODE_FAIL'
    }
  ];
  private requestId: string = '';
  // ====== For grid ========
  private listOptions = {
    name: 'recipient_list',
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    onLoadSearch: false,
    haveDataBodyHeight: 400,
    pageSize: '100',
    pageSizes: [
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      },
      {
        value: '500',
        name: 'COMMON_PAGE_SIZE_500'
      },
      {
        value: '1000',
        name: 'COMMON_PAGE_SIZE_1000'
      }
    ]
  };
  private gridProps = {
    options: {
      pageOptions: {
        perPage: 100,
        page: 1,
        totalCount: 0
      }
    },
    minBodyHeight: 31,
    scrollY: false,
    copyOptions: {
      useFormattedValue: true
    },
    columns: [
      {
        header: 'MAIL_SEND_LIST_POPUP_BOTTOM_HEADER_ONE',
        name: 'receiverAddress',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'MAIL_SEND_LIST_TABLE_HEADER_THREE',
        name: 'statusName',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'MAIL_SEND_LIST_POPUP_BOTTOM_HEADER_TWO',
        name: 'statusCodeName',
        align: 'center',
        minWidth: 85,
        formatter: data => {
          if (data.row.statusCode === 'READY') {
            return '';
          } else if (data.row.statusCode === 'PROGRESS') {
            return '';
          } else if (data.row.statusCode === 'COMPLETE') {
            return '성공';
          } else if (data.row.statusCode === 'FALL') {
            return '실패';
          }
        },
        copyOptions: {
          useFormattedValue: true
        }

      },
      {
        header: 'MAIL_SEND_LIST_POPUP_BOTTOM_HEADER_THREE',
        name: 'resultDateTime',
        align: 'center',
        minWidth: 85
      }
    ]
  };
  private totalCount: number = 0;
  private size: number = 100;
  private resetData(page: number = 1, size?: number) {
    if (size) {
      this.size = size;
    }
    this.showItems = this.mailMessageView.filter((item: any, idx: number) => {
      return (page - 1) * this.size <= idx && idx < page * this.size;
    });
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.size;
    this.gridProps.options.pageOptions.totalCount = this.mailMessageView.length;
  }
  private getMailMessages(): void {
    let theObj: GetMailMessagesViewRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        requestId: this.requestId,
        seq: Number(this.$route.query.seq)
      }
    };
    this.$api.getMailMessagesView(theObj).then(res => {
      Vue.set(res.data, 'statusCodeName', this.$t((this.statusCodeArr.find(key => key.value === res.data.statusCode) as any).label));
      this.mailMessageView = [res.data];
      this.totalCount = this.mailMessageView.length;
      this.resetData(1);
    });
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private beforeMount(): void {
    this.requestId = this.$route.query.requestId as string;
    this.getMailMessages();
  }
  private mounted(): void {
    this.$nextTick(() => {
      popupResize(1000, 950);
    });
  }
}
